import React from 'react';
var GroupeBouton = function (_a) {
    var children = _a.children, isHorizontal = _a.isHorizontal, alignementHorizontal = _a.alignementHorizontal, reverse = _a.reverse, taille = _a.taille, iconePosition = _a.iconePosition;
    var classGroupe = "fr-btns-group";
    if (isHorizontal) {
        classGroupe += ' fr-btns-group--inline';
    }
    if (alignementHorizontal && alignementHorizontal !== 'left') {
        classGroupe += ' fr-btns-group--' + alignementHorizontal;
    }
    if (reverse) {
        classGroupe += ' fr-btns-group--inline-reverse';
    }
    if (taille && taille !== "md") {
        classGroupe += " fr-btns-group--".concat(taille);
    }
    if (iconePosition) {
        classGroupe += " fr-btns-group--icon-".concat(iconePosition);
    }
    var creerLigne = function (child) {
        if (child) {
            return (React.createElement("li", { key: child.props.label }, child));
        }
        else {
            return;
        }
    };
    return (React.createElement("ul", { className: classGroupe }, Array.isArray(children) ?
        children.map(creerLigne) :
        creerLigne(children)));
};
export default GroupeBouton;
